import React from "react";
import { Button, MainWrapper, Wrapper } from "./index.styled";
import ErrorPage from "../../Assets/Images/ErrorPage.png";
import { useNavigate } from "react-router-dom";
import { viewSizeCalculator } from "../../utils";

const Error = () => {
  const navigate = useNavigate();

  return (
    <MainWrapper>
      <Wrapper>
        <img
          src={ErrorPage}
          alt="errorPage"
          style={{
            width: `${viewSizeCalculator(50.5)}`,
            height: `${viewSizeCalculator(33.6875)}`,
          }}
        />
        <Button
          onClick={() => {
            navigate("/");
          }}
        >
          Go Back Home
        </Button>
      </Wrapper>
    </MainWrapper>
  );
};

export default Error;
